import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-show',
  templateUrl: './menu-show.component.html',
  styleUrls: ['./menu-show.component.scss']
})
export class MenuShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
